
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/sale",
      function () {
        return require("private-next-pages/products/sale/index.tsx");
      }
    ]);
  